// frontend/admin-portal/src/components/procurement/PurchaseOrderStats.jsx
import React, { useEffect, useState } from "react";
import { Card, Title, Spinner } from "@fiberhome/shared-ui";
import { purchaseOrderService } from "../../services/purchaseOrderService";
import { useSettings } from "../../contexts/SettingsContext";

export default function PurchaseOrderStats({ refreshKey = 0 }) {
  const { get } = useSettings();
  const currency = get("finance.currencySymbol", "IQD");
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    purchaseOrderService
      .stats()
      .then((s) => alive && setStats(s))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [refreshKey]);

  const cards = [
    { label: "Total POs", value: stats?.total ?? "—" },
    {
      label: "Open",
      value: stats ? stats.draft + stats.sent + stats.partially : "—",
      variant: "warning",
    },
    { label: "Received", value: stats?.received ?? "—", variant: "success" },
    {
      label: "Open Value",
      value: stats
        ? `${currency} ${Number(stats.openValue).toLocaleString()}`
        : "—",
      variant: "primary",
    },
  ];

  return (
    <div className="row g-3 mb-4">
      {cards.map((c) => (
        <div className="col-md-3 col-sm-6" key={c.label}>
          <Card hoverable>
            <div className="text-muted" style={{ fontSize: 12 }}>
              {c.label}
            </div>
            <Title level={2} className="mb-0" style={{ fontSize: 20 }}>
              {loading ? <Spinner size="md" /> : c.value}
            </Title>
          </Card>
        </div>
      ))}
    </div>
  );
}
